var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HK---Product-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Inventory---Kitchen",
    fill: "#1B1C1F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,0 C37.7614237,0 40,2.23857625 40,5 L40,35 C40,37.7614237 37.7614237,40 35,40 L5,40 C2.23857625,40 0,37.7614237 0,35 L0,5 C0,2.23857625 2.23857625,0 5,0 L35,0 Z M35,2.5 L5,2.5 C3.68204776,2.5 2.6022936,3.51984724 2.50685717,4.81342207 L2.5,5 L2.5,35 C2.5,36.3179522 3.51984724,37.3977064 4.81342207,37.4931428 L5,37.5 L35,37.5 C36.3179522,37.5 37.3977064,36.4801528 37.4931428,35.1865779 L37.5,35 L37.5,5 C37.5,3.68204776 36.4801528,2.6022936 35.1865779,2.50685717 L35,2.5 Z M37.6456078,10.6437415 C37.9689741,10.0338026 38.7255675,9.80148953 39.3355065,10.1248558 C39.9018784,10.4251246 40.1426443,11.0989411 39.9152446,11.68202 L39.8543922,11.8147546 L29.2744678,31.7707857 C28.9052379,32.4672333 28.0030584,32.6425822 27.4019475,32.1717717 L27.2859866,32.0689571 L20.01375,24.79375 L7.19352681,39.5491609 C6.77553415,40.0301721 6.07065475,40.1143299 5.55482939,39.7682716 L5.43008711,39.6727749 C4.9490759,39.2547822 4.86491816,38.5499028 5.21097647,38.0340774 L5.30647319,37.9093352 L19.0075848,22.1425796 C19.4490976,21.6345022 20.2046501,21.5729503 20.7206324,21.977239 L20.8352005,22.0788145 L27.8575,29.10375 L37.6456078,10.6437415 Z M13.125,6.25 C16.9219577,6.25 20,9.32804235 20,13.125 C20,16.9219577 16.9219577,20 13.125,20 C9.32804235,20 6.25,16.9219577 6.25,13.125 C6.25,9.32804235 9.32804235,6.25 13.125,6.25 Z M13.125,8.75 C10.7087542,8.75 8.75,10.7087542 8.75,13.125 C8.75,15.5412458 10.7087542,17.5 13.125,17.5 C15.5412458,17.5 17.5,15.5412458 17.5,13.125 C17.5,10.7087542 15.5412458,8.75 13.125,8.75 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.566419f9f60b410b01656d3cd9ae2683.svg";
export { ForwardRef as ReactComponent };